import PuxPageDetails from "../../../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import SmartTable from "../../../../../global/components/table/table.vue";

import getTableApi from "../../../../../const/TableApis";

const TABLE_ID = "BerichtFormblattKurse";

// @vue/component
export default {
  name: "BerichtFormblattKurse",
  components: {
    PuxPageDetails,
    SmartTable,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: "_TXT_BERICHT_FORMBLATT_KURSE_ACTION_",
            route: "root.foerderantrag.details",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            label: "_TXT_BERICHT_FORMBLATT_KURSE_ACTION_DOWNLOADPDF_",
            type: "link",
            className: "btn btn-primary",
            icon: "glyphicon-download",
            href: "/api/berichte/formblatt_kurse/pdf/",
            urlParams: true,
          },
        ],
        sortable: true,
        pagination: true,
        details: false,
        showHeader: false,
        view: {
          filter: "top",
        },
      },
    };
  },
};
